<template>
    <div class="section">
        <div class="center-section">
            <div class="form-heading">
                <h1>Create new password</h1>
                <p class="caption">
                    Your new password must be different from used passwords
                </p>
            </div>
           
            <div class="signup-form">
               
                <form @submit.prevent="handleSubmit">
                    <base-input class="form-group" 
                                type="pass" 
                                placeholder="New password" 
                                required icon="lock"
                                v-model="email">
                    </base-input>

                    <base-input class="form-group" 
                                type="pass" 
                                placeholder="Confirm password" 
                                required icon="lock"
                                v-model="password">
                    </base-input>

                    <primary-btn>Send</primary-btn>
              </form>
            </div>

            <div class="login-link caption">
                <router-link to="/login" class="link">Back to sign in</router-link>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref } from 'vue';
import BaseInput from '@/components/BaseInput.vue';
import PrimaryBtn from '@/components/PrimaryBtn.vue';

const email = ref('');
const password = ref('');

function handleSubmit() {
    console.log('Email:', email.value, 'Password:', password.value);
}
</script>

<style scoped>
    .signup-btn-group {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 1vh;
    }

    .center-section {
        width: 35%;
        margin: auto;
    }

    .form-heading {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: 1vh;
        text-align: center;
    }

    .form-heading .caption {
        color: rgba(255, 255, 255, .4);
        width: 50%;
    }

    .form-heading img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }

    .signup-form {
        padding: 2.5vh;
        margin-bottom: 24px;
        background-color: rgba(255, 255, 255, 0.1) !important;
        border-radius: 20px;
    }

    .reset {
        margin-top: 1vh;
        display: flex;
        justify-content: center;
    }

    .form-group {
        padding: 1vh;
    }

    .login-link {
        text-align: center;
        color: rgba(255, 255, 255, .4);
    }

    .link {
        color: white;
        text-decoration: none;
    }
</style>